module.exports = __webpack_public_path__ + "static/media/hand-holding.52ab5759.svg";